













import { Component, Prop, Vue } from "vue-property-decorator";

export type MessagePanelKind = "info" | "warning" | "danger" | "ghost";

const KIND_ICONS: Record<MessagePanelKind, string> = {
  info: "annotation-info",
  warning: "annotation-alert",
  danger: "annotation-x",
  ghost: "annotation-dots",
};

@Component
export default class MessagePanel extends Vue {
  @Prop({
    default: "info",
    validator: (value: string) => value in KIND_ICONS,
  })
  readonly kind!: MessagePanelKind;

  get icon(): string {
    return KIND_ICONS[this.kind];
  }
}
